import { apiClient } from "./apiClient";
import type { ApiResponse, LookupItem } from "./types";
import { unwrapApiResponse, unwrapPagedItems } from "../shared/utils/apiResponse";

export async function fetchLookup(url: string, q = ""): Promise<LookupItem[]> {
  const { data } = await apiClient.get<ApiResponse<unknown[]>>(url, { params: { pageSize: 2000, ...(q ? { q } : {}) } });
  const unwrapped = unwrapApiResponse(data) ?? [];
  const items = Array.isArray(unwrapped) ? unwrapped : unwrapPagedItems(unwrapped).items;
  return items.map((item: any) => {
    const accountNumber = item.accountNumber ?? item.AccountNumber;
    const accountName = item.accountName ?? item.AccountName;
    const accountLabel = accountNumber
      ? accountName ? `${accountNumber} - ${accountName}` : accountNumber
      : accountName;

    return {
      id: item.id ?? item.value ?? item.Id ?? item.Value,
      label: accountLabel ?? item.name ?? item.text ?? item.label ?? item.Name ?? item.Text ?? "Unnamed",
      subtitle: item.code ?? item.Code ?? item.phone ?? item.Phone ?? item.gstin ?? item.Gstin ?? undefined,
      raw: item
    };
  });
}
